import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'

import FormInput from '../inputFields/FormInput'
import { useFieldArray } from 'react-hook-form'
import { FlexColumn, FormRow, CenteredRowContainer } from '../styles/Containers'
import { Subheading } from '../styles/Text'
import { SecondaryButton, IconButton } from '../common/Button'

const FieldContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: flex-start;
  flex-basis: 23.5%;

  div {
    width: 100% !important;
  }
`

const DeleteButton = styled(IconButton)`
  margin-top: 31px;
`

function AdditionalRecipients({ loading = false }) {
  const { fields, append, remove } = useFieldArray({ name: 'additionalRecipients' })

  return (
    <FlexColumn>
      {fields.length > 0 && <Subheading>Additional Recipients</Subheading>}
      <FormRow>
        {fields.map((field, index) => (
          <FieldContainer key={field.id}>
            <FormInput
              required={true}
              id={`additionalRecipients.${index}.email`}
              label="Recipient Email"
              disabled={loading}
              basis="auto"
              value={field.email}
            />
            <DeleteButton color="secondary" onClick={() => remove(index)} aria-label="Delete email" disabled={loading}>
              <DeleteIcon />
            </DeleteButton>
          </FieldContainer>
        ))}
      </FormRow>
      <CenteredRowContainer>
        <SecondaryButton onClick={() => append({ email: '' })} disabled={loading}>
          <AddIcon />
          Add Additional Recipient
        </SecondaryButton>
      </CenteredRowContainer>
    </FlexColumn>
  )
}

AdditionalRecipients.propTypes = {
  loading: PropTypes.bool
}

export default AdditionalRecipients
